import { render, staticRenderFns } from "./legalHome.vue?vue&type=template&id=307019e9&scoped=true"
import script from "./legalHome.vue?vue&type=script&lang=js"
export * from "./legalHome.vue?vue&type=script&lang=js"
import style0 from "./legalHome.vue?vue&type=style&index=0&id=307019e9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307019e9",
  null
  
)

export default component.exports